(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   window load
 *   drupal behavior
 *
 *  -------------------------------------------------- */

/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {	
		const $body = $('body');
		
		if($body.hasClass('node--type-series') || $body.hasClass('node--type-product')) {
			
			const $bgContainer = $('.color-list-outer-wrapper');
			const $list = $('.color-item');

			const $initialBG = $('<div data-id="0" class="color-block-bg active"></div>');

			//set initial active list item and bg image
			$($list[0]).addClass('active');

			$initialBG.css('background-image', `url(${$($list[0]).attr('data-image-url')})`);

			$initialBG.imagesLoaded( { background: true }, function() {
				$initialBG.prependTo($bgContainer);
			});			

			//for each list item
			$list.each(function(index){
				const $this = $(this);
				const $img = $this.attr('data-image-url');
				
				$this.on('click', function(){
					$list.removeClass('active');
					$this.addClass('active');
					$('.color-block-bg').removeClass('active');
					//if div has been created
					if($(`div[data-id="${index}"]`).length) {
						$(`div[data-id="${index}"]`).addClass('active');
					} else {
						const $newDiv = $(`<div data-id=${index} class="color-block-bg active"></div>`);
						$newDiv.css('background-image', `url(${$img})`);

						$newDiv.imagesLoaded( { background: true }, function() {
							$newDiv.prependTo($bgContainer);
						});	

					}

				});

			});

		}

	});

	$(window).resize(function() {

	});


/** --------------------------------------------------
    #window load
    -------------------------------------------------- */

	$(window).on('load', function() {
		
	});




})(jQuery);
